module.exports = __webpack_public_path__ + "static/media/57 - Logo PPI Amsterdam.fb48399e.png";